<template>
  <div id="showCustomerNameAndInstructions">
    <div class="row g-3 align-items-center mb-3">
      <div class="col-auto d-block mx-auto">
        <div class="form-floating" :class="{ 'form-data-error': userNameErr }">
          <input
            type="text"
            id="userNameInput"
            placeholder="Customer Name"
            class="form-control w300"
            @keyup="validateCustomerOrderName($event)"
            @change="validateCustomerOrderName($event)"
            v-model.trim="userName"
          />
          <label for="userNameInput">
            <faIcons :icon="['fas', 'user-circle']" /> Customer Name
          </label>
          <span class="error-feedback" v-if="userNameErr">
            {{ userNameMsg }}
          </span>
        </div>
      </div>
    </div>

    <div class="row g-3 align-items-center mb-3">
      <div class="col-auto d-block mx-auto">
        <div class="form-floating" :class="{ 'form-data-error': userPhoneErr }">
          <input
            type="number"
            min="0"
            id="userPhoneInput"
            placeholder="Customer Phone (optional)"
            @keydown="
              if ($event.key === '.' || $event.key === '+' || $event.key === '-' ) {
                $event.preventDefault();
              }
            "
            @keyup="validateCustomerOrderPhone($event)"
            @change="validateCustomerOrderPhone($event)"
            class="form-control w300"
            v-model.trim="userPhone"
          />
          <label for="userPhoneInput">
            <faIcons :icon="['fas', 'phone']" /> Customer Phone (optional)
          </label>
          <span class="error-feedback" v-if="userPhoneErr">
            {{ userPhoneMsg }}
          </span>
        </div>
      </div>
    </div>

    <!-- <div class="row g-3 align-items-center mb-3">
      <div class="col-auto d-block mx-auto">
        <div
          class="form-floating"
          :class="{ 'form-data-error': userAddressErr }"
        >
          <textarea
            id="userAddressInput"
            placeholder="Order Instructions (optional)"
            @input="validateCustomerOrderAddress($event)"
            class="form-control w300 h100"
            v-model.trim="userAddress"
          />
          <label for="userAddressInput">
            <faIcons :icon="['fas', 'address-book']" /> Order Instructions
            (optional)
          </label>
          <span class="error-feedback" v-if="userAddressErr">
            {{ userAddressMsg }}
          </span>
        </div>
      </div>
    </div> -->

    <div class="d-grid gap-3" v-if="userName.length > 0">
      <div class="d-grid gap-3">
        <button
          class="btn btn-success btn-block"
          id="payOnlineOrderBtn"
          v-if="
            isuserAddressValidated == true &&
            isuserPhoneValidated == true &&
            isuserNameValidated == true
          "
          :disabled="!this.$store.state.__CartTotal > 0"
          type="button"
          onclick="pay()"
        >
          Place Pick-up order now
        </button>
      </div>
      <div class="clearfix"></div>
      <div class="d-grid gap-3" id="showOrderPaymentError"></div>
      <div id="token_response"></div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerAndOrderNotesDetails",
  data() {
    return {
      //address
      userAddress: "",
      userAddressErr: false,
      userAddressMsg: "",
      isuserAddressValidated: true,
      //phone
      userPhone: "",
      userPhoneErr: false,
      userPhoneMsg: "",
      isuserPhoneValidated: true,
      //name
      userName: "",
      userNameErr: false,
      userNameMsg: "",
      isuserNameValidated: false,
    };
  },
  mounted() {
    // show current order details
    let currentRestaurants = localStorage.getItem("current_customer_order");
    this.currentOrder = JSON.parse(currentRestaurants);
    let currentOrderData = localStorage.getItem("current_customer_order");
    let currentRestaurantsData = localStorage.getItem(
      "current_restaurants_data_public"
    );
    let currentOrder = JSON.parse(currentOrderData);
    let currentRestaurant = JSON.parse(currentRestaurantsData).filter(
      (restInfo) => restInfo.rest_id == currentOrder.restId
    );
    console.table(currentRestaurant);
    console.log("hello");
    this.pickUpAddress = currentRestaurant[0].rest_address;
    this.pickUpPhoneNumber = currentRestaurant[0].rest_phone;
    // let script001 = document.createElement('link');
    // script001.setAttribute('rel', 'stylesheet');
    // script001.setAttribute('href', 'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.1.3/css/bootstrap.min.css');
    // document.head.appendChild(script001);
    let script01 = document.createElement("script");
    script01.setAttribute("src", "https://code.jquery.com/jquery-3.3.1.min.js");
    document.head.appendChild(script01);
    // let script0 = document.createElement('script');
    // script0.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js');
    // document.head.appendChild(script0);
    // let script2 = document.createElement('script');
    // script2.setAttribute('src', 'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js');
    // document.head.appendChild(script2);
    let script1 = document.createElement("script");
    script1.setAttribute("src", "https://checkout.stripe.com/checkout.js");
    document.head.appendChild(script1);
    let payFunction = document.createElement("script");
    payFunction.setAttribute(
      "src",
      "http://localhost/php/Resturant-POS-PHP-VUE-MODULE/checkout.js"
    );
    document.head.appendChild(payFunction);
  },
  methods: {
    validateCustomerOrderName(e) {
      let val = e.target.value;
      this.validateCustomerOrderNameInput(val);
    },
    validateCustomerOrderNameInput(val) {
      let currentOrderData = localStorage.getItem("current_customer_order");
      let currentOrder = JSON.parse(currentOrderData);
      if (val == "") {
        currentOrder["cust_name"] = val;
        this.userNameErr = true;
        this.isuserNameValidated = false;
        this.userNameMsg = "Must enter your name ..";
      } else {
        currentOrder["cust_name"] = val;
        this.userNameErr = false;
        this.isuserNameValidated = true;
        this.userNameMsg = "";
      }
      localStorage.setItem(
        "current_customer_order",
        JSON.stringify(currentOrder)
      );
    },
    validateCustomerOrderPhone(e) {
      let val = e.target.value;
      this.validateCustomerOrderPhoneInput(val);
    },
    validateCustomerOrderPhoneInput(val) {
      // let userPhoneRegex = /^\d{10}$/;
      let currentOrderData = localStorage.getItem("current_customer_order");
      let currentOrder = JSON.parse(currentOrderData);
      console.log("Customer Phone is: " + val);
      if (val.length > 0) {
        if (val !== "") {
          if (
            (val !== "" && val.length < 9) ||
            (val !== "" && val.length > 11)
          ) {
            currentOrder["cust_phone"] = "";
            this.userPhoneErr = true;
            this.isuserPhoneValidated = false;
            this.userPhoneMsg = "Must Only Enter 9-11 Digits ..";
          } else {
            currentOrder["cust_phone"] = val;
            this.userPhoneErr = false;
            this.isuserPhoneValidated = true;
            this.userPhoneMsg = "";
          }
        } else {
          currentOrder["cust_phone"] = val;
          this.userPhoneErr = false;
          this.isuserPhoneValidated = true;
          this.userPhoneMsg = "";
        }
      } else {
        currentOrder["cust_phone"] = "";
        this.userPhoneErr = false;
        this.isuserPhoneValidated = true;
        this.userPhoneMsg = "";
      }
      localStorage.setItem(
        "current_customer_order",
        JSON.stringify(currentOrder)
      );
    },
    validateCustomerOrderAddress(e) {
      let val = e.target.value;
      this.validateCustomerOrderAddressInput(val);
    },
    validateCustomerOrderAddressInput(val) {
      let currentOrderData = localStorage.getItem("current_customer_order");
      let currentOrder = JSON.parse(currentOrderData);
      console.log("Order instructions Is: " + val);
      if (val.length > 0) {
        currentOrder["cust_notes"] = val;
        this.userAddressErr = false;
        this.isuserAddressValidated = true;
        this.userAddressMsg = "";
      } else {
        currentOrder["cust_notes"] = "";
      }
      localStorage.setItem(
        "current_customer_order",
        JSON.stringify(currentOrder)
      );
    },
  },
};
</script>

<style></style>
